<script>
import Layout from "@/views/layouts/main";
import PageHeader from "@/components/page-header";
import appConfig from "@/app.config";
import { authComputed } from "@/state/helpers";
import store from "@/state/store";
import { VueEditor } from "vue2-editor";

export default {
  beforeRouteEnter(to, from, next) {
    const userType = store.getters["auth/getUser"].user_type;
    if (userType === 2 || userType === 3) {
      next();
    } else {
      alert("You are not allowed to access this page. You will be redirected.");
      next("/");
    }
  },
  page: {
    title: "Performance Development Plan Details",
    meta: [{ name: "description", content: appConfig.description }],
  },
  components: {
    Layout,
    PageHeader,
    VueEditor,
  },
  computed: {
    ...authComputed,
  },
  mounted() {
    this.performanceId = this.$route.params.id;
     this.getPerformanceDevPlanDetails();
  },
  data() {
    return {
      title: "Performance Development Plan Details",
      items: [
        {
          text: "IHUMANE",
        },
        {
          text: "Dashboard",
          href: "/",
        },
        {
          text: "Performance Development Plan Details",
          active: true,
        },
      ],
      texts: [
        /*{ id: 0, goal: null },
        { id: 1, goal: null },
        { id: 2, goal: null },*/
      ],
      goals:[],
      field:5,
      performance_dev:null,
      employee:null,
      status:null,
      supervisor:null,
      start_date:null,
      end_date:null,
      performanceId:null,
      type:null,
    };
  },
  methods: {
    addField() {
      this.texts.push({ id: this.count++, goal: null });
      this.count++;
    },
    delField(index) {
      if (index > 0) {
        this.texts.splice(index, 1);
      }
    },
    async getPerformanceDevPlanDetails() {
      const url = `${this.ROUTES.performanceImprovement}/get-performance-dev-details/${this.performanceId}`;
      await this.apiGet(url).then((res) => {
        const { data } = res;
        this.performance_dev = data.performance;
        this.performanceId = this.performance_dev.ppm_id;
        switch (parseInt(this.performance_dev.ppm_status)) {
          case 0:
            this.status = 'Pending';
            break;
          case 1:
            this.status = 'In Review';
            break;
          case 2:
            this.status = 'Approved';
            break;
        }
        this.type =  `${ parseInt(this.performance_dev.ppm_type) === 1 ? 'Development' : 'Improvement' }`
        this.employee = `${this.performance_dev.employee?.emp_first_name } ${ this.performance_dev.employee?.emp_last_name } (${ this.performance_dev.employee?.emp_unique_id })`;
        this.supervisor = `${this.performance_dev.supervisor?.emp_first_name } ${ this.performance_dev.supervisor?.emp_last_name } (${ this.performance_dev.supervisor?.emp_unique_id })`;
        this.start_date = new Date(this.performance_dev.ppm_start_date).toDateString();
        this.end_date = new Date(this.performance_dev.ppm_end_date).toDateString();

        const assessments = data.performance.assessment;
        assessments.map(assess=>{
          this.texts.push({ id: assess.ppa_id, goal: assess.ppa_goal });
        });

      });
    },
    submitPerformancePlan() {
      const employeeID = this.getEmployee.emp_id;
      const url = `${this.ROUTES.performanceImprovement}/add-performance-plan`;
      this.goals = [];
      let validForm = true;
      this.texts.every(async (field) => {
        if (field.goal === "" || !field.goal) {
          this.apiFormHandler("Invalid Goal Fields");
          validForm = false;
          return false;
        }
        const data = {
          goal: field.goal,
        };
        this.goals.push(data);
        return true;
      });
      if (validForm) {
        const data = {
          goals:this.goals,
          employee:employeeID,
          type:1,//performance development
        }
        this.apiPost(url, data, "Add goals Error").then(() => {
          this.apiResponseHandler("Process Complete", "Goals Added");
          this.getSelfAssessment();


        });
      }
    },
  },
};
</script>

<template>
  <Layout>
    <PageHeader :title="title" :items="items" />
    <div class="d-flex justify-content-end mb-3">
      <b-button
        class="btn btn-success"
        @click="$router.push({ name: 'performance-development-plan' })"
      >
        <i class="mdi mdi-view-list mr-2"></i>
        Performance Dev. Plans
      </b-button>
    </div>
    <scale-loader v-if="apiBusy" />
    <div class="row">
      <div
        class="col-lg-8"
      >
        <div class="card">
          <div class="card-body">
            <div class="p-3 bg-light mb-4">
              <h5 class="font-size-14 mb-0">Performance Development Form</h5>
            </div>
            <div class="mb-3">

              <p class="mt-3">
                Work with your manager to discuss and agree on at least
                <strong>3</strong> goals for your work over this review period.
              </p>
              <p>
                Try to write at least 2-3 performance goals, focused on your key
                areas of responsibility. Then, write 1 goal about an area of
                growth/development. To create a development goal, consider a
                strength you would like to get even better in, or a challenging
                area you wish to improve in.
              </p>
              <p>
                Your goals should be SMART (specific, measurable, actionable,
                realistic, timebound). For tips on creating SMART goals,
                <a
                  href="https://rescue.box.com/s/v5a0wfucoe1drhrz2cepy6wzr6urr3hr"
                  target="_blank"
                >
                  click here.
                </a>
                For an e-learning module on how to write a good goal,
                <a
                  href="https://kayaconnect.org/auth/saml2/login.php?wants=https://kayaconnect.org/course/info.php?id=1276&idp=dbcf769ab2c00b042dd2189fca3b115f&passive=off"
                  target="_blank"
                >
                  click here.
                </a>
              </p>
            </div>
            <form  @submit.prevent="submitPerformancePlan">
              <div class="row" v-for="(field, index) in texts" :key="index">
                <div class="col mb-5">
                  <div class="form-group">
                    <label for="goal">
                      Goal {{ index + 1 }} <span class="text-danger">* </span>
                    </label>
                    <vue-editor style="height: 200px; border: none;" v-model="field.goal"
                                class="form-control"></vue-editor>
                  </div>
                </div>
              </div>

              <div >
                <!-- <div class="alert alert-info d-flex mt-3">
                  <i class="ri-error-warning-line mr-2"></i>
                  You must submit a minimum of 3 goals.
                  <span style="cursor: pointer" class="ml-1" @click="addField">
                    Click here to add a new goal
                  </span>
                </div> -->
                <div class="row">
                  <div class="col-12">
                    <b-button
                      v-if="!submitting"
                      class="btn btn-success btn-block mt-4"
                      type="submit"
                      :disabled="status != 'Pending' "
                    >
                      Save changes
                    </b-button>
                    <b-button
                      v-else
                      disabled
                      class="btn btn-success btn-block mt-4"
                      type="submit"
                    >
                      Submitting...
                    </b-button>
                  </div>
                </div>
              </div>
            </form>
          </div>
        </div>
      </div>
      <div class="col-lg-4">
        <div class="card">
          <div class="card-body">
            <div class="p-3 bg-light mb-4 d-flex justify-content-between">
              <div class="d-inline mb-0">
                <h5 class="font-size-14 mb-0">Other Details</h5>
              </div>
            </div>
            <div class="d-flex justify-content-between mb-3">
              <span>Employee Name</span>
              <span>
                {{ employee }}
              </span>
            </div>
            <div class="d-flex justify-content-between mb-3">
              <span>Supervisor</span>
              <span> {{ supervisor }} </span>
            </div>
            <div class="d-flex justify-content-between mb-3">
              <span>Start Date</span>
              <span>
                {{ start_date }}
              </span>
            </div>
            <div class="d-flex justify-content-between mb-3">
              <span>End Date</span>
              <span>
                {{ end_date }}
              </span>
            </div>
            <div class="d-flex justify-content-between mb-3">
              <span>Status</span>
              <span> {{ status }} </span>
            </div>
            <div class="d-flex justify-content-between mb-3">
              <span>Type</span>
              <span> {{ type }} </span>
            </div>
          </div>
        </div>
      </div>
    </div>
  </Layout>
</template>
